module.exports = __webpack_public_path__ + "fonts/2a7329bdbb3200025c7d01b76710a298.otf";